export enum ChoiceType {
  Training = 'Intergrip\\Domain\\Models\\Training',
  Other = 'Intergrip\\Modules\\Transfer\\Domain\\Models\\OtherChoice',
}
